import { render, staticRenderFns } from "./Toi.vue?vue&type=template&id=e2841682&"
import script from "./Toi.vue?vue&type=script&lang=js&"
export * from "./Toi.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports